import React, { useState } from 'react';
import shortid from 'shortid';

import SectionContainer from 'components/sectionContainer';
import { Title } from 'components/typography';
import Filters from 'components/filters';
import Collapsible from 'components/collapsible';

import {
  faqSection,
  sectionIntro,
  faqFilters,
  faqList,
} from './scss/Faq.module.scss';
import { FAQS, FAQ_CATEGORIES } from './faq.constants';

const Faq = () => {
  const [activeFilter, setActiveFilter] = useState(FAQ_CATEGORIES[0]);
  const activeList = FAQS.filter(({ category }) => category === activeFilter);

  return (
    <SectionContainer className={faqSection}>
      <div className={sectionIntro}>
        <Title size="xl" value="Frequently asked questions" />
        <p>
          Here are the questions we get asked a lot answered by some of our
          Xperts. If you can't find your specific query here, send us an email
          at contactus@afexnigeria.com
        </p>
      </div>
      <Filters
        className={faqFilters}
        options={FAQ_CATEGORIES}
        theme="basic"
        onSelect={setActiveFilter}
      />
      <div className={faqList}>
        {activeList.map(item => (
          <div key={shortid()}>
            <Collapsible label={item.question} content={item.answer} />
          </div>
        ))}
      </div>
    </SectionContainer>
  );
};

export default Faq;
